export enum CPOwnerSetting {
    All = 0,
    Public = 1,
    Mine = 2,
    Subscription = 3
}